import { CreateBooking } from '@/models/bookings';
import i18n from '@/plugins/i18n';
import moment from 'moment';
import { CREATE_BOOKING_DATE_FORMAT, TELLIQ_DATE_FORMAT } from './constants';

export const isProduction = (): boolean => process.env.NODE_ENV === 'production';
export const isDevelopment = (): boolean => process.env.NODE_ENV === 'development';

export const bookingStartDateReconstruction = (booking: CreateBooking): string => {
  return `${bookingDateFormat(booking.startDate)}T${booking.startTime}Z`;
};

export const bookingEndDateReconstruction = (booking: CreateBooking): string => {
  return `${bookingDateFormat(booking.endDate)}T${booking.endTime}Z`;
};

export const bookingDateFormat = (date?: string): string =>
  moment(date, CREATE_BOOKING_DATE_FORMAT).format(TELLIQ_DATE_FORMAT);

export interface ConfirmationDialogText {
  delete: {
    title: string;
    text: string;
  };
  check_out: {
    title: string;
    text: string;
  };
}

export const confirmationDialogText = (): ConfirmationDialogText => {
  return {
    delete: {
      title: i18n.t('bookings.dialogs.delete.title'),
      text: i18n.t('bookings.dialogs.delete.description'),
    },
    check_out: {
      title: i18n.t('bookings.dialogs.checkout.title'),
      text: i18n.t('bookings.dialogs.checkout.description'),
    },
  };
};

export const tabNames = (): string[] => {
  return [i18n.t('bookings.vehicle_type.business'), i18n.t('bookings.vehicle_type.private')];
};
